import SignIn from '../components/SignIn'

export const SignInPage = SignIn

export const RootPage = SignInPage
